/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RentedInputs */

const cs_enum_rented = /** @type {(inputs: Enum_RentedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronajato`)
};

const en_enum_rented = /** @type {(inputs: Enum_RentedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rented`)
};

/**
* | output |
* | --- |
* | "Rented" |
*
* @param {Enum_RentedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_rented = /** @type {((inputs?: Enum_RentedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RentedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_rented(inputs)
	return cs_enum_rented(inputs)
});